"use client";
import React, { useState } from "react";
import Image from "next/image";
import { AnimatePresence, motion } from "framer-motion";
import { cn } from "@/lib/cn";

interface itemsInterface {
  image: any;
}
const Caroussel = ({
  items,
  className,
}: {
  items: itemsInterface[];
  className: string;
}) => {
  const [seletcedIndex, setSelectedIndex] = useState(0);
  return (
    <div className={cn("w-full flex flex-col gap-", className)}>
      <div className="relative w-full aspect-square flex items-center gap-4 justify-center border border-neutral-800 rounded-xl bg-[#FAFAFA]">
        <AnimatePresence>
          <motion.div
            className="absolute flex items-center justify-center"
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0, zIndex: -10 }}
            key={items[seletcedIndex].image.src}
          >
            <Image
              src={items[seletcedIndex].image}
              alt={"image of the caroussel of the cards" + seletcedIndex}
              className=" max-w-[70%]  rounded-xl"
            />
          </motion.div>
        </AnimatePresence>
      </div>

      <div
        className="w-full place-items-center mt-8 max-w-"
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${items.length},1fr)`,
          gap: ".8rem",
        }}
      >
        {items.map((item, index) => {
          return (
            <div
              key={"caroussel-item" + index}
              className={cn(
                "border border-neutral-800 rounded place-items-center grid p-2 cursor-pointer transition-colors w-full aspect-square max-w-[4.5rem]",
                seletcedIndex === index ? "border-neutral-500" : ""
              )}
              onClick={() => setSelectedIndex(index)}
            >
              <Image
                src={item.image}
                alt={`image of caroussel ` + index}
                className={cn(" max-w-[50%] md:max-w-12 object-contain")}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Caroussel;
